import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { styles } from "../styles";
import { staggerContainer } from "../utils/motion";
import { trackSectionView, trackSectionTime } from "../services/trackingService";

const SectionWrapper = (Component, idName, amountViewport, customPadding) => {
  const HOC = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
      if (!idName || !sectionRef.current) return;

      let viewTracked = false;
      let visibleSince = null;
      let accumulatedMs = 0;

      const flushTime = () => {
        if (visibleSince !== null) {
          accumulatedMs += Date.now() - visibleSince;
          visibleSince = null;
        }
        if (accumulatedMs > 0) {
          trackSectionTime(idName, accumulatedMs / 1000);
          accumulatedMs = 0;
        }
      };

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            if (!viewTracked) {
              trackSectionView(idName);
              viewTracked = true;
            }
            if (visibleSince === null) visibleSince = Date.now();
          } else if (visibleSince !== null) {
            accumulatedMs += Date.now() - visibleSince;
            visibleSince = null;
          }
        },
        { threshold: 0.3 }
      );
      observer.observe(sectionRef.current);

      const handleHidden = () => {
        if (document.visibilityState === "hidden") flushTime();
      };
      document.addEventListener("visibilitychange", handleHidden);
      window.addEventListener("pagehide", flushTime);

      return () => {
        observer.disconnect();
        document.removeEventListener("visibilitychange", handleHidden);
        window.removeEventListener("pagehide", flushTime);
        flushTime();
      };
    }, []);

    return (
      <motion.section
        ref={sectionRef}
        variants={staggerContainer()}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: amountViewport }}
        className={`${customPadding || styles.padding} max-w-7xl mx-auto relative z-0`}
      >
        <span className="hash-span" id={idName}>
          &nbsp;
        </span>
        <Component />
      </motion.section>
    );
  };
  return HOC;
};

export default SectionWrapper;
